import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import KanBoIcon from 'components/KanBoIcon'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import Scrollbars from 'components/Scrollbars'
import Activities from 'components/Activities'
import Notification from '../Notification'
import Notifications from '../Notifications'
import NotificationSettings from '../UserSettings/components/Notifications'
import withLeftSidebar from 'components/Sidebar/withLeftSidebar'
import Alert from 'components/Alert'

export class UnreadNotifications extends React.Component {
  static propTypes = {
    leftSidebar: PropTypes.object.isRequired,

    isLoaded: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    lastLoadedId: PropTypes.number,
    currentUser: PropTypes.object.isRequired,
    activities: PropTypes.array.isRequired,
    unreadOnly: PropTypes.bool.isRequired,
    unreadNotificationCount: PropTypes.number.isRequired,

    fetchActivities: PropTypes.func.isRequired,
    requestMarkAllNotificationsAsRead: PropTypes.func.isRequired,
    setNotificationsUnreadOnly: PropTypes.func.isRequired
  }

  componentDidMount () {
    if (!this.props.unreadOnly) {
      this.props.setNotificationsUnreadOnly(true)
    }
  }

  handleMarkAllAsReadClick = () => {
    this.props.requestMarkAllNotificationsAsRead()
  }

  handleShowAllClick = () => {
    this.props.leftSidebar.push(Notifications, { id: 'notifications' })
  }

  handleSettingsClick = () => {
    this.props.leftSidebar.push(NotificationSettings, { id: 'notifications' })
  }

  render () {
    const {
      isLoaded,
      isLoading,
      lastLoadedId,
      currentUser,
      activities,
      unreadOnly,
      unreadNotificationCount,

      fetchActivities
    } = this.props

    return (
      <LeftSidebarView
        title={<FormattedMessage id='NOTIFICATIONS_HEADER' />}
        menu={[{
          icon: <KanBoIcon name='kanbo-16-tasks' />,
          title: <FormattedMessage id='NOTIFICATIONS_MARK_ALL_AS_READ' />,
          onClick: this.handleMarkAllAsReadClick,
          disabled: !unreadNotificationCount
        }, {
          icon: <KanBoIcon name='kanbo-16-stream' />,
          title: <FormattedMessage id='NOTIFICATIONS_SHOW_ALL' />,
          onClick: this.handleShowAllClick
        }, {
          icon: <KanBoIcon name='kanbo-16-settings' />,
          title: <FormattedMessage id='SETTINGS' />,
          onClick: this.handleSettingsClick
        }]}
      >
        <Scrollbars
          component={ViewBody}
        >
          {!unreadNotificationCount &&
            <Alert>
              <FormattedMessage id='NOTIFICATIONS_ALL_READ' />
            </Alert>
          }
          <Activities
            key={unreadOnly}
            context='notifications'
            isLoaded={isLoaded}
            isLoading={isLoading}
            lastLoadedId={lastLoadedId}
            currentUser={currentUser}
            activities={activities}
            activityComponent={Notification}
            fetchActivities={fetchActivities}
          />
        </Scrollbars>
      </LeftSidebarView>
    )
  }
}

export default withLeftSidebar(UnreadNotifications)
